import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ConfirmDeleteModal from "../ConfirmDelete";
import folder_svg from "../../assets/folder.svg";
import CollectionDisplay from "./CollectionDisplay";
import {
  Checkbox,
  Typography,
  Tooltip,
  Popover,
  Grid,
  TextField,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import TransferListModal from "./TransferListModal";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  addcollection,
  getcollection,
} from "../../redux/slices/collectionSlice";
import {
  getSelectedIndexes,
  updateIndexes,
} from "../../redux/slices/conversationSlice";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import apiCall from "../../utils/apiCall";
import { DELETE_USER_FOLDER } from "../../endpoint";
import { addError } from "../../redux/slices/errorSlice";
import {
  loadingforindexes,
  loadingforSharedDocs,
} from "../../redux/slices/loadingSlice";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import ShareIcon from "@mui/icons-material/Share";
import InfoIcon from "@mui/icons-material/Info";
import DoneIcon from "@mui/icons-material/Done";
import SharedUser from "../SharedUser";
import {
  GET_USER_EMAILS,
  DELETE_SHARED_COLLECTION,
  GET_WITH_WHOM_COLLECTION_IS_SHARED,
  GET_COLLECTION_OWNER,
  SHARE_COLLECTION_WITH,
} from "../../endpoint";
import { addSuccessMessage } from "../../redux/slices/errorSlice";
const CollectionFolder: React.FC<any> = ({
  data,
  refreshState,
  category,
  setSharedCollection,
}): React.ReactElement => {
  console.log(category)
  const [showFiles, setShowFiles] = React.useState(false);
  const dispatch = useAppDispatch();
  const[confirmOpen,setConfirmOpen]=React.useState(false)
  const[folderToDelete,setFolderToDelete]=React.useState<string>("")
  const [files, setFiles] = React.useState<string[]>([]);
  const [images, setImages] = React.useState<string[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & SVGSVGElement) | null
  >(null);

  const [sharedBy, setSharedBy] = React.useState("");

  const [sharedEmail, setSharedEmail] = React.useState<string>("");
  const [emails, setEmails] = React.useState<string[]>([]);
  const [showSharedUsers, setShowSharedUsers] = React.useState<boolean>(false);
  const [userEmails, setUserEmails] = React.useState<{ user_email: string }[]>(
    []
  );
  const [filteredEmails, setFilteredEmails] = React.useState<string[]>([]);
  const [showSuggestions, setShowSuggestions] = React.useState<boolean>(false);
  const selectedIndex = useAppSelector(getSelectedIndexes);

  React.useEffect(() => {
    const files: any[] = [];
    const images: any[] = [];
    data[1]?.forEach((d: any) => {
      if (d.file_type === "doc") {
        files.push(d.file_name);
      } else {
        images.push(d.file_name);
      }
    });
    setImages(images);
    setFiles(files);
  }, [data]);

  React.useEffect(() => {
    const fetchData = () => {
      apiCall("GET", GET_USER_EMAILS)
        .then((res) => {
          setUserEmails(res.result);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchData();
  }, []);

  // const deleteFolder = (index: string) => {
  //   apiCall("POST", DELETE_USER_FOLDER, {
  //     folder_name: index,
  //   }).then(() => refreshState())
  //     .catch((err) => {
  //       dispatch(addError("Failed to delete a collection.Please try again."))
  //     })
  // };
  const deleteFolder = (index: string) => {
    if (category === "Own") {
      dispatch(loadingforindexes(true));
      apiCall("POST", DELETE_USER_FOLDER, {
        folder_name: index,
      })
        .then(() => refreshState())
        .finally(() => {
          dispatch(loadingforindexes(false));
        });
    } else if (category === "shared") {
      dispatch(loadingforSharedDocs(true));
      apiCall("POST", DELETE_SHARED_COLLECTION, {
        collection_name: index,
      }).then((res) => {
        if (res.result === undefined) {
          dispatch(addError("Something Went wrong while deleting shared docs"));
          dispatch(loadingforSharedDocs(false));
        } else {
          setSharedCollection(res.result);
          dispatch(loadingforSharedDocs(false));
        }
      });
    }
  };
const handleConfirmDelete=()=>{
  deleteFolder(folderToDelete)
  setConfirmOpen(false)
  setFolderToDelete("")
}
  const getSharedUsers = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    apiCall("POST", GET_WITH_WHOM_COLLECTION_IS_SHARED, {
      collection_name: data[0],
    })
      .then((res) => {
        setEmails(res.result);
        setShowSharedUsers(true);
      })
      .catch((err) => {
        dispatch(addError("Something went wrong while getting shared users"));
        console.error(err);
      })
      .finally(() => {
        //setShowSharedUsers(false);
        //setEmails([]);
      });
  };

  const handleClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClickCoPresentIcon = (
    event: React.MouseEvent<SVGSVGElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    apiCall("POST", GET_COLLECTION_OWNER, {
      collection_name: data[0],
    })
      .then((res) => {
        setSharedBy(res.result);
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const shareDocument = () => {
    apiCall("POST", SHARE_COLLECTION_WITH, {
      shared_user_email: sharedEmail,
      collection_name: data[0],
    })
      .then((res) => {
        if (res.result === "user not found") {
          dispatch(addError("User not found"));
        } else {
          dispatch(addSuccessMessage("Successfully shared the collection"));
          handleClose();
        }
      })
      .catch((err) => {
        dispatch(addError("Something went wrong while adding user"));
        console.error(err);
      });
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setSharedEmail(inputValue);
    const suggestion = userEmails
      .map((item) => item?.user_email)
      .filter((email) =>
        email.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
      );
    setFilteredEmails(suggestion);
    setShowSuggestions(!!inputValue);
  };

  const handleSelectSuggestion = (email: string) => {
    setSharedEmail(email);
    setShowSuggestions(false);
  };

  return (
    <div>
      <Accordion
        sx={{
          ".Mui-expanded": {
            minHeight: 0,
            marginBottom: 1,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Checkbox
            id="collectioncheckbox"
            color="success"
            sx={{
              m: 0,
              p: 0,
              mr: 0.5,
            }}
            size="small"
            checked={data[0] === selectedIndex[0]}
            onChange={(e) => {
              e?.stopPropagation();
              if (e.target.checked) {
                dispatch(updateIndexes([data[0]]));
                dispatch(
                  addcollection({
                    name: data[0],
                    files,
                    images,
                  })
                );
              } else {
                dispatch(updateIndexes([""]));
                dispatch(
                  addcollection({
                    name: "",
                    files: [],
                    images: [],
                  })
                );
              }
            }}
            onClick={(e) => e.stopPropagation()}
          />
          <img
            src={folder_svg}
            alt="folder svg"
            width="20px"
            height="20px"
            style={{
              marginRight: "5px",
            }}
          />
          {/* <Typography
            sx={{
              flex: 1,
            }}
          >
            {data[0]}
          </Typography> */}

          {data[0]?.length > 6 ? (
            <Tooltip title={data[0]}>
              <Typography
                sx={{
                  width:'60px'
                }}
              >
                {data[0].substring(0, 6) + "..."}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              sx={{
                width:'60px'
              }}
            >
              {data[0]}
            </Typography>
          )}

          {/* <EditIcon
            id="editcollection"
            color="secondary"
            onClick={(e) => {
              e?.stopPropagation();
              dispatch(
                addcollection({
                  name: data[0],
                  files,
                  images,
                })
              );
              setShowFiles(true);
            }}
            fontSize="small"
          /> */}

          {category === "Own" ? (
            <>
              <Tooltip title="Edit">
                <EditIcon
                  color="primary"
                  onClick={(e) => {
                    e?.stopPropagation();
                    dispatch(
                      addcollection({
                        name: data[0],
                        files,
                        images,
                      })
                    );
                    setShowFiles(true);
                  }}
                  fontSize="small"
                />
              </Tooltip>
            </>
          ) : null}

          {category === "shared" ? (
            <>
              <Tooltip title="Shared By">
                <CoPresentIcon
                  color="primary"
                  fontSize="small"
                  onClick={(e) => handleClickCoPresentIcon(e)}
                />
              </Tooltip>
            </>
          ) : null}
          <Tooltip title="Delete">
            <DeleteOutlineIcon
              data-testid="deletecollection"
              id="deletecollectionicon"
              color="primary"
              onClick={(e) => {
                e?.stopPropagation();
                setFolderToDelete(data[0]);
                setConfirmOpen(true)
              }}
              fontSize="small"
            />
          </Tooltip>
          {category === "Own" ? (
            <>
              <Tooltip title="Share">
                <ShareIcon
                  color="primary"
                  fontSize="small"
                  onClick={(e) => handleClick(e)}
                />
              </Tooltip>
              <Tooltip title="Shared with">
                <InfoIcon
                  color="primary"
                  fontSize="small"
                  onClick={(e) => getSharedUsers(e)}
                />
              </Tooltip>{" "}
            </>
          ) : null}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            mt: 0,
            pt: 0,
          }}
        >
          {data[1]?.length === 0 ? (
            <Typography fontSize="small" color="secondary" textAlign="center">
              No files uploaded yet
            </Typography>
          ) : (
            <>
              {files.map((file: string, i) => (
                <CollectionDisplay fileType="pdf" type={file} key={i} />
              ))}
              {images.map((image: string, i) => (
                <CollectionDisplay fileType="png" type={image} key={i} />
              ))}
            </>
          )}
        </AccordionDetails>
      </Accordion>
      <TransferListModal
        open={showFiles}
        setOpen={setShowFiles}
        refreshstate={refreshState}
      />
      {category === "Own" ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          sx={{
            ".MuiPopover-paper": {
              width: "300px",
            },
          }}
        >
          <Grid container alignItems="center">
            <TextField
              value={sharedEmail}
              onChange={handleEmailChange}
              label="Enter email"
              // sx={{ mt: 2 }}
              variant="standard"
              sx={{
                m: 0.5,
                flex: 1,
              }}
              size="small"
              onFocus={() => setShowSuggestions(true)}
            />
            <DoneIcon
              color="success"
              fontSize="small"
              onClick={() => shareDocument()}
              sx={{
                mr: 1,
                cursor: "pointer",
              }}
            />
          </Grid>
          {showSuggestions && filteredEmails.length > 0 && (
            <List
              sx={{
                maxHeight: filteredEmails.length > 4 ? "160px" : "auto",
                overflow: filteredEmails.length > 4 ? "auto" : "visible",
                borderTop: "1px solid #ccc",
                padding: 0,
              }}
            >
              {filteredEmails.map((email, index) => (
                <ListItem
                  key={index}
                  sx={{
                    "&:hover": { background: "#f0f0f0" },
                    cursor: "pointer",
                  }}
                  onClick={() => handleSelectSuggestion(email)}
                >
                  <ListItemText
                    primary={email}
                    sx={{
                      padding: "4px",
                    }}
                    primaryTypographyProps={{
                      fontSize: "0.875rem",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          )}
          {showSuggestions && filteredEmails.length === 0 && (
            <Box sx={{ padding: "8px" }}>
              <Typography variant="body2">No matches found</Typography>
            </Box>
          )}
        </Popover>
      ) : null}

      {category === "shared" ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          sx={{
            ".MuiPopover-paper": {
              p: 1,
              m: 1,
            },
          }}
        >
          <Typography>Shared by {sharedBy}</Typography>
        </Popover>
      ) : null}
      <SharedUser
        open={showSharedUsers}
        setOpen={setShowSharedUsers}
        data={emails}
      />
      <ConfirmDeleteModal
      show={confirmOpen}
      cancel={()=>{
        setConfirmOpen(false)
        setFolderToDelete("")

      }}
      confirm={handleConfirmDelete}
      />
    </div>
  );
};

export default CollectionFolder;
